import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  Response,
  ImageResultDto,
} from '@/models';

class ImageService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/image';

  public getImageUrl(imageId: string): string {
    return this.ROOT_API + '/tire/' + imageId;
  }

  public saveTireImage(summerTireImages: File[], winterTireImages: File[]): AxiosPromise<Response<ImageResultDto>> {
    const formData = new FormData();
    summerTireImages.forEach((image) => {
      formData.append('summerTireImages[]', image);
    });
    winterTireImages.forEach((image) => {
      formData.append('winterTireImages[]', image);
    });
    return Vue.axios.post<Response<ImageResultDto>>(this.ROOT_API + '/tire', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  public saveTireScratchImage(summerTireImages: File[], winterTireImages: File[]): AxiosPromise<Response<ImageResultDto>> {
    const formData = new FormData();
    summerTireImages.forEach((image) => {
      formData.append('summerTireImages[]', image);
    });
    winterTireImages.forEach((image) => {
      formData.append('winterTireImages[]', image);
    });
    return Vue.axios.post<Response<ImageResultDto>>(this.ROOT_API + '/tire-scratch', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

}
export const imageService = new ImageService();
